import type React from "react";
import { useEffect, useState } from "react";
import type { User } from "@qbanq/shared";
import { api, ApiError } from "../api/client";
import { useAuth } from "../auth/AuthContext";

export function UsersPage() {
  const { user: me } = useAuth();
  const [users, setUsers] = useState<User[]>([]);
  const [email, setEmail] = useState("");
  const [displayName, setDisplayName] = useState("");
  const [password, setPassword] = useState("");
  const [role, setRole] = useState<"admin" | "agent">("agent");
  const [error, setError] = useState<string | null>(null);
  const [forbidden, setForbidden] = useState(false);

  function load() {
    api
      .get<User[]>("/api/users")
      .then(setUsers)
      .catch((e) => {
        if (e instanceof ApiError && e.status === 403) setForbidden(true);
      });
  }
  useEffect(load, []);

  async function create(e: React.FormEvent) {
    e.preventDefault();
    setError(null);
    try {
      await api.post("/api/users", { email, display_name: displayName, password, role });
      setEmail("");
      setDisplayName("");
      setPassword("");
      load();
    } catch (err) {
      setError(err instanceof Error ? err.message : "Failed");
    }
  }

  async function toggleDisabled(u: User) {
    await api.post(`/api/users/${u.id}/${u.disabled ? "enable" : "disable"}`);
    load();
  }

  if (forbidden) {
    return (
      <div>
        <h2>Users</h2>
        <p className="error">Admins only.</p>
      </div>
    );
  }

  return (
    <div>
      <h2>Users</h2>
      <p className="muted">Admins manage console access. Agents can work the inbox but not change configuration.</p>

      <div className="card">
        <h3>Add user</h3>
        <form onSubmit={create}>
          <div className="row">
            <div className="field" style={{ flex: 1 }}>
              <label>Email</label>
              <input value={email} onChange={(e) => setEmail(e.target.value)} />
            </div>
            <div className="field" style={{ flex: 1 }}>
              <label>Display name</label>
              <input value={displayName} onChange={(e) => setDisplayName(e.target.value)} />
            </div>
          </div>
          <div className="row">
            <div className="field" style={{ flex: 1 }}>
              <label>Password</label>
              <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} />
            </div>
            <div className="field" style={{ width: 160 }}>
              <label>Role</label>
              <select value={role} onChange={(e) => setRole(e.target.value as "admin" | "agent")}>
                <option value="agent">agent</option>
                <option value="admin">admin</option>
              </select>
            </div>
          </div>
          {error && <p className="error">{error}</p>}
          <button className="btn" type="submit">Create user</button>
        </form>
      </div>

      <div className="card">
        <table>
          <thead>
            <tr><th>Email</th><th>Name</th><th>Role</th><th>Status</th><th></th></tr>
          </thead>
          <tbody>
            {users.map((u) => (
              <tr key={u.id}>
                <td>{u.email}</td>
                <td>{u.display_name}</td>
                <td className="muted">{u.role}</td>
                <td>{u.disabled ? <span className="error">disabled</span> : "active"}</td>
                <td>
                  {u.id !== me?.id && (
                    <button className="btn secondary" onClick={() => toggleDisabled(u)}>
                      {u.disabled ? "Enable" : "Disable"}
                    </button>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
